import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DescriptionIcon from "@mui/icons-material/Description";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import CampaignIcon from "@mui/icons-material/Campaign";

// Registry of sub-dashboards available under the Managers Dashboard.
// Most dashboards' content lives outside this portal (a separate route/app)
// — clicking those tiles navigates out to `externalUrl`. A dashboard whose
// data already lives in this portal instead sets `path` to an internal
// route (see ManagersDashboardHome.js / AppCard.js for how both are handled).
// Keep the `key` values in sync with backend/config/managerDashboards.js.
export const managerDashboards = [
  {
    key: "importFiles",
    label: "תיקי ייבוא",
    icon: SnippetFolderIcon,
    iconColor: "#0ea5e9",
    gradient: "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)",
    shadowColor: "rgba(14, 165, 233, 0.3)",
    externalUrl: `${process.env.REACT_APP_AUTOMATIONS}/ImportStatistics`,
    openInNewTab: false,
  },
  {
    key: "purchaseInvoices",
    label: "חשבוניות רכש",
    icon: DescriptionIcon,
    iconColor: "#4CAF50",
    gradient: "linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)",
    shadowColor: "rgba(76, 175, 80, 0.2)",
    externalUrl: `${process.env.REACT_APP_PURCHASE_INVOICES_URL?.replace(/\/$/, "")}/InvoiceStatistics`,
    openInNewTab: false,
  },
  {
    key: "approveLinesStats",
    label: "השהיות סחר",
    icon: LocalShippingIcon,
    iconColor: "#4B9FD1",
    gradient: "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)",
    shadowColor: "rgba(75, 159, 209, 0.3)",
    path: "/ApproveLinesStatistics",
  },
  {
    key: "customerPortal",
    label: "פורטל לקוחות",
    icon: PeopleAltIcon,
    iconColor: "#8E24AA",
    gradient: "linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)",
    shadowColor: "rgba(142, 36, 170, 0.3)",
    path: "/CustomerPortal",
  },
  {
    key: "salesPromotionsStats",
    label: 'קד"מ ודוגמיות',
    icon: CampaignIcon,
    iconColor: "#F4511E",
    gradient: "linear-gradient(135deg, #FFEDEA 0%, #FFD7D2 100%)",
    shadowColor: "rgba(255, 138, 101, 0.2)",
    path: "/SalesPromotionsStatistics",
  },
];
